// Scheduler.jsx
import React, { useState, useEffect} from 'react';
import '../../../styles/scheduler.css';
import moment from 'moment';
import EventCard from './eventcard';

const getDateRange = (start, end) => {
  const range = [];
  let current = moment(start);
  const last = moment(end);

  while (current <= last) {
    range.push(current.clone());
    current.add(1, 'day');
  }

  return range;
};
const hours = Array.from({ length: 18 }, (_, i) => 6 + i); // 6 AM to 11 PM


const Scheduler = ({ events, startDate, endDate, onCardAction }) => {
  const dateRange = getDateRange(startDate, endDate);

 const [now, setNow] = useState(moment());
const currentHour = now.hour() + now.minute() / 60;
const topPosition = (currentHour - 6) * 60; 


useEffect(() => {
  const interval = setInterval(() => setNow(moment()), 60000); // update every minute
  return () => clearInterval(interval);
}, []);

  return (
    <div className="scheduler-container">
      <div className="scheduler-header">
        <div className="time-column"></div>
        {dateRange.map(date => (
          <div className="day-column" key={date.format('YYYY-MM-DD')}>
            {date.format("ddd, MMM D")}
          </div>
        ))}
      </div>

      <div className="scheduler-body">
        <div className="current-time-line" style={{ top: `${topPosition}px` }}></div>
        {hours.map(hour => (
          <div className="time-row" key={hour}>
            <div className="time-label">{moment().startOf('day').add(hour, 'hours').format("h:mm A")}</div>
            {dateRange.map(date => (
              <div className="day-cell" key={date.format('YYYY-MM-DD') + hour}></div>
            ))}
          </div>
        ))}

        {/* Render Events */}
        {events.map(event => {
          const eventDate = moment(event.date);
          const columnIndex = dateRange.findIndex(d => d.isSame(eventDate, 'day'));
          if (columnIndex === -1) return null;

          return (
            <EventCard
              key={event.title + event.date}
              event={event}
              columnIndex={columnIndex} onCardAction={onCardAction}
            />
          );
        })}
      </div>
    </div>
  );
};
export default Scheduler;
